<template>
  <div v-if="currentUser && (currentUser.type == 'TeleConsultant' || currentUser.type == 'NRP' || currentUser.type == 'CancelledOrder' || currentUser.type =='ToRemind')">
    <!-- Start Button Section - Modern Landing -->
    <div
      v-if="showButtonStart == true"
      class="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4"
    >
      <div class="max-w-md w-full">
        <div class="bg-white rounded-2xl shadow-xl p-8 text-center">
          <!-- Call Center Operator Illustration -->
          <div class="mx-auto w-32 h-32 mb-6">
            <svg viewBox="0 0 200 200" class="w-full h-full">
              <!-- Background circle -->
              <circle cx="100" cy="100" r="95" fill="url(#bgGradient)" stroke="#e5e7eb" stroke-width="2"/>
              
              <!-- Gradients -->
              <defs>
                <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style="stop-color:#dbeafe;stop-opacity:1" />
                  <stop offset="100%" style="stop-color:#e0e7ff;stop-opacity:1" />
                </linearGradient>
                <linearGradient id="skinGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style="stop-color:#fde68a;stop-opacity:1" />
                  <stop offset="100%" style="stop-color:#f59e0b;stop-opacity:1" />
                </linearGradient>
                <linearGradient id="hairGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style="stop-color:#92400e;stop-opacity:1" />
                  <stop offset="100%" style="stop-color:#78350f;stop-opacity:1" />
                </linearGradient>
              </defs>
              
              <!-- Hair -->
              <path d="M70 60 Q100 45 130 60 Q125 70 120 75 Q110 65 100 65 Q90 65 80 75 Q75 70 70 60" fill="url(#hairGradient)"/>
              
              <!-- Face -->
              <ellipse cx="100" cy="85" rx="25" ry="30" fill="url(#skinGradient)"/>
              
              <!-- Eyes -->
              <circle cx="92" cy="80" r="2" fill="#1f2937"/>
              <circle cx="108" cy="80" r="2" fill="#1f2937"/>
              <circle cx="93" cy="79" r="0.5" fill="#ffffff"/>
              <circle cx="109" cy="79" r="0.5" fill="#ffffff"/>
              
              <!-- Nose -->
              <path d="M100 85 L98 88 L102 88 Z" fill="#f59e0b" opacity="0.6"/>
              
              <!-- Mouth -->
              <path d="M96 92 Q100 95 104 92" stroke="#1f2937" stroke-width="1.5" fill="none" stroke-linecap="round"/>
              
              <!-- Headset -->
              <path d="M75 70 Q100 60 125 70" stroke="#374151" stroke-width="4" fill="none"/>
              <circle cx="75" cy="70" r="8" fill="#374151"/>
              <circle cx="75" cy="70" r="6" fill="#1f2937"/>
              <circle cx="125" cy="70" r="8" fill="#374151"/>
              <circle cx="125" cy="70" r="6" fill="#1f2937"/>
              
              <!-- Microphone -->
              <rect x="70" y="85" width="3" height="12" fill="#374151"/>
              <circle cx="68" cy="91" r="4" fill="#1f2937"/>
              <circle cx="68" cy="91" r="2" fill="#6b7280"/>
              
              <!-- Body/Shirt -->
              <path d="M75 115 Q100 110 125 115 L130 140 Q100 135 70 140 Z" fill="#3b82f6"/>
              <path d="M85 120 Q100 118 115 120 L118 135 Q100 133 82 135 Z" fill="#2563eb"/>
              
              <!-- Arms -->
              <ellipse cx="65" cy="125" rx="8" ry="15" fill="url(#skinGradient)" transform="rotate(-20 65 125)"/>
              <ellipse cx="135" cy="125" rx="8" ry="15" fill="url(#skinGradient)" transform="rotate(20 135 125)"/>
              
              <!-- Hands typing -->
              <circle cx="60" cy="135" r="4" fill="url(#skinGradient)"/>
              <circle cx="140" cy="135" r="4" fill="url(#skinGradient)"/>
              
              <!-- Computer screen suggestion -->
              <rect x="85" y="145" width="30" height="20" rx="2" fill="#e5e7eb" stroke="#9ca3af"/>
              <rect x="87" y="147" width="26" height="14" fill="#3b82f6" opacity="0.3"/>
              <circle cx="100" cy="154" r="1" fill="#10b981"/>
              
              <!-- Desk -->
              <rect x="50" y="160" width="100" height="8" fill="#d1d5db" rx="2"/>
              
              <!-- Decorative elements -->
              <circle cx="150" cy="50" r="3" fill="#f59e0b" opacity="0.3"/>
              <circle cx="45" cy="55" r="2" fill="#10b981" opacity="0.4"/>
              <circle cx="155" cy="145" r="2" fill="#8b5cf6" opacity="0.4"/>
            </svg>
          </div>
          
          <!-- Title -->
          <h2 class="text-2xl font-bold text-gray-900 mb-4">{{$t('confirmation_order')}}</h2>
          <p class="text-gray-600 mb-8">Prêt à confirmer la commande</p>

          <!-- Modern Start Button -->
          <button  
            class="w-full relative bg-gradient-to-r from-red-600 to-red-600 hover:from-red-700 hover:to-red-700 text-white font-semibold py-4 px-8 rounded-xl transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-blue-200 shadow-lg"
            :disabled="loading" 
            v-if="showButtonStart == true" 
            @click="startConfirmation(null)"
          >
            <loading :active.sync="loading" :is-full-page="fullPage"></loading>
            <span class="flex items-center justify-center">
              <span v-if="!vShow">{{$t('start')}}</span>
              <span v-else>{{$t('continue')}}</span>
              <svg class="ml-3 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
              </svg>
            </span>
          </button>
        </div>
      </div>
    </div>

    <!-- Main Order Confirmation Page -->
    <div v-if="order._id && showButtonStart == false" class="min-h-screen bg-gray-50">
      
     <!-- Premium Header with Advanced Timer -->
     <div class="bg-gradient-to-r from-slate-50 to-blue-50 shadow-lg border-b border-gray-200">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div class="flex items-center justify-center">
            <!-- Left Section: Title & Status -->
            
            <!-- Center: Premium Timer -->
            <div id="gettingValuesExample" class="bg-white rounded-2xl shadow-xl border border-gray-200 px-8 py-4">
              <div class="text-center mb-2">
                <p class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Temps de session</p>
              </div>
              <div class="flex items-center justify-center space-x-6">
                <!-- Hours -->
                <div class="text-center">
                  <div class="relative">
                    <div class="w-16 h-16 bg-gradient-to-br from-black to-black rounded-xl flex items-center justify-center shadow-lg">
                      <span class="text-2xl font-bold text-white hours">0</span>
                    </div>
                   
                  </div>
                  <span class="text-xs font-medium text-gray-600 mt-2 block">Heures</span>
                </div>
                
                <!-- Separator -->
                <div class="flex flex-col items-center">
                  <div class="w-1 h-1 bg-gray-400 rounded-full mb-1"></div>
                  <div class="w-1 h-1 bg-gray-400 rounded-full"></div>
                </div>
                
                <!-- Minutes -->
                <div class="text-center">
                  <div class="relative">
                    <div class="w-16 h-16 bg-gradient-to-br from-black to-black rounded-xl flex items-center justify-center shadow-lg">
                      <span class="text-2xl font-bold text-white minutes">0</span>
                    </div>
                   
                  </div>
                  <span class="text-xs font-medium text-gray-600 mt-2 block">Minutes</span>
                </div>
                
                <!-- Separator -->
                <div class="flex flex-col items-center">
                  <div class="w-1 h-1 bg-gray-400 rounded-full mb-1"></div>
                  <div class="w-1 h-1 bg-gray-400 rounded-full"></div>
                </div>
                
                <!-- Seconds -->
                <div class="text-center">
                  <div class="relative">
                    <div class="w-16 h-16 bg-gradient-to-br from-black to-black rounded-xl flex items-center justify-center shadow-lg">
                      <span class="text-2xl font-bold text-white seconds">0</span>
                    </div>
                    
                  </div>
                  <span class="text-xs font-medium text-gray-600 mt-2 block">Secondes</span>
                </div>
              </div>
            </div>
            
            
          </div>
          
        </div>
      </div>

      <!-- Price Reduction Alerts - Modern Design -->
      <div v-if="order.priceReduction && order.priceReduction.status === 'approuvé'" 
          class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div class="reduction-accept from-green-50 to-emerald-50 border-l-4 border-green-500 rounded-xl shadow-sm p-6">
          <div class="flex items-start">
            <div class="flex-shrink-0">
              <div class="flex items-center justify-center w-10 h-10 bg-green-500 rounded-full">
                <svg class="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
                </svg>
              </div>
            </div>
            
            <div class="ml-4 flex-1">
              <div class="flex justify-between items-start mb-4">
                <h3 class="text-lg font-semibold text-green-800">
                  Réduction de prix approuvée!
                </h3>
                <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  APPROUVÉ
                </span>
              </div>
              
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div class="bg-white rounded-lg p-4 border border-red-200">
                  <p class="text-sm text-gray-600 mb-1">Prix original</p>
                  <p class="text-xl font-bold text-red-600 line-through">
                    {{ order.priceReduction.originalPrice }} {{ idWharhouse.currency }}
                  </p>
                </div>
                <div class="bg-white rounded-lg p-4 border border-green-200">
                  <p class="text-sm text-gray-600 mb-1">Nouveau prix</p>
                  <p class="text-xl font-bold text-green-700">
                    {{ order.priceReduction.proposedPrice }} {{ idWharhouse.currency }}
                  </p>
                </div>
              </div>
              
              <div class="bg-green-100 rounded-lg p-4 mb-4">
                <div class="flex justify-between items-center">
                  <span class="text-sm font-semibold text-green-800">
                    Économie: {{ (order.priceReduction.originalPrice - order.priceReduction.proposedPrice).toFixed(2) }} {{ idWharhouse.currency }}
                  </span>
                  <span class="text-sm font-semibold text-green-800">
                    {{ ((order.priceReduction.originalPrice - order.priceReduction.proposedPrice) / order.priceReduction.originalPrice * 100).toFixed(1) }}%
                  </span>
                </div>
              </div>
              
              <div v-if="order.priceReduction.adminResponse.responseComment" 
                  class="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
                <p class="text-sm text-blue-800">
                  <strong>Commentaire admin:</strong> {{ order.priceReduction.adminResponse.responseComment }}
                </p>
              </div>
              
              <div class="bg-amber-50 border border-gray-500 rounded-lg p-4">
                <div class="flex items-start">
                  <svg class="w-5 h-5 text-amber-600 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                  </svg>
                  <p class="text-amber-800 font-medium text-sm">
                    <strong>IMPORTANT:</strong> Demandez au client s'il accepte ce nouveau prix avant de confirmer!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Rejected Price Reduction Alert -->
      <div v-if="order.priceReduction && order.priceReduction.status === 'rejeté'" 
          class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div class="reduction-reject from-red-50 to-pink-50 border-l-4 border-red-500 rounded-xl shadow-sm p-6">
          <div class="flex items-start">
            <div class="flex-shrink-0">
              <div class="flex items-center justify-center w-10 h-10 bg-red-500 rounded-full">
                <svg class="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"></path>
                </svg>
              </div>
            </div>
            
            <div class="ml-4 flex-1">
              <div class="flex justify-between items-start mb-4">
                <h3 class="text-lg font-semibold text-red-800">
                  Réduction de prix refusée
                </h3>
                <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                  REFUSÉ
                </span>
              </div>
              
              <div class="bg-white rounded-lg p-4 border border-gray-200 mb-4">
                <p class="text-sm text-gray-600 mb-1">Prix maintenu</p>
                <p class="text-xl font-bold text-gray-800">
                  {{ order.priceReduction.originalPrice }} {{ idWharhouse.currency }}
                </p>
              </div>
              
              <div v-if="order.priceReduction.adminResponse.responseComment" 
                  class="bg-white rounded-lg p-4 border border-red-200 mb-4">
                <p class="text-sm">
                  <strong class="text-red-800">Raison du refus:</strong> 
                  <span class="text-red-700">{{ order.priceReduction.adminResponse.responseComment }}</span>
                </p>
              </div>
              
              <div class="bg-gray-50 border border-gray-500 rounded-lg p-4">
                <div class="flex items-start">
                  <svg class="w-5 h-5 text-gray-500 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  <p class="text-gray-700 text-sm">
                    Procédez avec le prix original. La demande de réduction a été examinée mais n'a pas été acceptée.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Content Area -->
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        
        <!-- Double Orders Card - Modern -->
        <div class="bg-white rounded-xl shadow-sm border border-gray-200 mb-6">
          <div class="px-6 py-4 border-b border-gray-200">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <div class="p-2 bg-blue-100 rounded-lg mr-3">
                  <svg class="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V7M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"></path>
                  </svg>
                </div>
                <h3 class="text-lg font-semibold text-gray-900">{{$t('Double orders')}}</h3>
              </div>
              <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-800">
                {{dataDouble.length}}
              </span>
            </div>
          </div>
          
          <div class="px-6 py-8 text-center">
            <div class="mb-4">
              <div class="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
                <svg class="w-8 h-8 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V7M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"></path>
                </svg>
              </div>
            </div>
            
            <h5 class="text-lg font-semibold text-gray-900 mb-2">
              <span v-if="loadingDouble" class="flex items-center justify-center">
                {{$t('Checking')}} ...
                <div class="ml-2 flex space-x-1">
                  <div class="w-2 h-2 bg-blue-600 rounded-full animate-bounce"></div>
                  <div class="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style="animation-delay: 0.1s"></div>
                  <div class="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style="animation-delay: 0.2s"></div>
                </div>
              </span>
              <span v-else>
                {{$t('Number of order doubled by this phone')}} ({{dataDouble.length}})
                <span v-if="dataDouble.length>0">
                  <button @click="$vm2.open('ModalDouble')" class="ml-2 p-1 text-blue-600 hover:text-blue-800">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                    </svg>
                  </button>
                </span>
              </span>
            </h5>
            <p class="text-gray-600">{{$t('Phone number')}}: {{order.customer.phone}}</p>
          </div>
        </div>

        <!-- Order Summary Cards - Modern Grid -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div class="flex items-center">
              <div class="p-3 bg-blue-100 rounded-lg">
                <svg class="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
              </div>
              <div class="ml-4">
                <p class="text-sm font-medium text-gray-600">{{$t('order')}}</p>
                <p class="text-lg font-semibold text-gray-900">#{{ order.id }}</p>
              </div>
            </div>
          </div>

          <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div class="flex items-center">
              <div class="p-3 bg-green-100 rounded-lg">
                <svg class="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
              </div>
              <div class="ml-4">
                <p class="text-sm font-medium text-gray-600">{{$t('order_date')}}</p>
                <p class="text-lg font-semibold text-gray-900">{{ order.date }}</p>
              </div>
            </div>
          </div>

          <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div class="flex items-center">
              <div class="p-3 bg-purple-100 rounded-lg">
                <svg class="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
              </div>
              <div class="ml-4">
                <p class="text-sm font-medium text-gray-600">{{$t('seller')}}</p>
                <p class="text-lg font-semibold text-gray-900">{{ order.seller.fullName||order.seller.email }}</p>
              </div>
            </div>
          </div>

          <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div class="flex items-center">
              <div class="p-3 bg-indigo-100 rounded-lg">
                <svg class="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
                </svg>
              </div>
              <div class="ml-4">
                <p class="text-sm font-medium text-gray-600">{{$t('store')}}</p>
                <p class="text-lg font-semibold text-gray-900">{{ order.source }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Reminder Alert - Modern -->
        <div v-if="order.remind && !loading" class="bg-blue-50 border-l-4 border-blue-500 rounded-xl p-6 mb-6">
          <div class="flex items-start">
            <div class="flex-shrink-0">
              <svg class="w-6 h-6 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
              </svg>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-semibold text-blue-800">Commande reportée</h3>
              <div class="mt-2 text-sm text-blue-700">
                Cette commande est déjà reportée pour la date {{ $moment(order.remind).format('yyyy-MM-DD HH:mm') }}.
                <p v-if="order.comment" class="mt-1"><strong>Raison:</strong> {{ order.comment }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Main Content Grid -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
          
          <!-- Products Section - Modern -->
          <div class="bg-white rounded-xl shadow-sm border border-gray-200">
            <div class="px-6 py-4 border-b border-gray-200">
              <div class="flex items-center">
                <div class="p-2 bg-orange-100 rounded-lg mr-3">
                  <svg class="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
                  </svg>
                </div>
                <h3 class="text-lg font-semibold text-gray-900">{{$t('order_products')}}</h3>
              </div>
            </div>

            <div class="overflow-hidden">
              <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-50">
                    <tr>
                      <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{$t('product')}}
                      </th>
                      <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{$t('quantity')}}
                      </th>
                      <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{$t('unit_price')}}
                      </th>
                      <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{$t('Page produit')}}
                      </th>
                      <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{$t('action')}}
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="(it, indx) in order.details" :key="it._id" class="hover:bg-gray-50">
                      <td class="px-6 py-4">
                        <div class="flex items-center">
                          <div class="flex-shrink-0 h-12 w-12">
                            <expandable-image 
                              class="h-12 w-12 rounded-lg object-cover" 
                              :src="it.product.picture?it.product.picture:'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'" 
                              alt="Product image" 
                            />
                          </div>
                          <div class="ml-4">
                            <div class="text-sm font-medium text-gray-900">{{ it.product.name }}</div>
                            <div v-if="checkUpselExist(it.product)" 
                                 @click="openModal('upsell', it.product.name,checkUpselExist(it.product))" 
                                 class="mt-1 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 cursor-pointer hover:bg-red-200 border border-dashed border-red-300">
                              <span class="font-semibold">Up-Sells</span>
                              <svg class="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"></path>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <div class="text-sm text-gray-900 font-medium">{{ it.quantity }}</div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <div class="text-sm text-gray-900 font-medium">
                          {{ it.unitPrice?it.unitPrice.toFixed():0 }} 
                          <sup v-if="idWharhouse" class="text-xs text-gray-500">{{idWharhouse.currency}}</sup>
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap text-center">
                        <a v-if="it.product.verificationLink && $f.validURL(it.product.verificationLink)" 
                           :href="it.product.verificationLink" 
                           target="_blank" 
                           class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800 hover:bg-blue-200">
                          <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                          </svg>
                          Voir
                        </a>
                        <span v-else class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                          Non défini
                        </span>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap text-center">
                        <button @click="$vm2.open('updateorders')" 
                                class="text-indigo-600 hover:text-indigo-900 p-1 rounded-lg hover:bg-indigo-50">
                          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                          </svg>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <!-- Total Price Section - Modern -->
              <div class="px-6 py-4 bg-gray-50 border-t border-gray-200">
                <div class="flex items-center justify-between">
                  <span class="text-base font-semibold text-gray-900">{{$t('total_price')}}:</span>
                  <div class="flex items-center">
                    <span class="text-2xl font-bold text-green-600">
                      {{ order.totalPrice?order.totalPrice.toFixed():0 }}
                    </span>
                    <sup v-if="idWharhouse" class="ml-1 text-sm text-gray-500">{{idWharhouse.currency}}</sup>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Customer Information - Modern -->
          <div class="bg-white rounded-xl shadow-sm border border-gray-200">
            <div class="px-6 py-4 border-b border-gray-200">
              <div class="flex items-center">
                <div class="p-2 bg-green-100 rounded-lg mr-3">
                  <svg class="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                  </svg>
                </div>
                <h3 class="text-lg font-semibold text-gray-900">{{$t('customer_information')}}</h3>
              </div>
            </div>

            <div class="p-6">
              <!-- Call Customer Header -->
              <div class="text-center mb-6">
                <div class="mx-auto w-16 h-16 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center mb-4">
                  <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                  </svg>
                </div>
                <h4 class="text-xl font-semibold text-gray-900 mb-2">{{$t('call_customer')}}</h4>
              </div>

              <!-- Customer Information Form - Modern -->
              <div class="space-y-4">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <!-- Full Name -->
                  <div class="space-y-1">
                    <label class="block text-sm font-medium text-gray-700">
                      {{$t('full_name')}} *
                    </label>
                    <div class="relative">
                      <input
                        type="text"
                        disabled
                        v-model="order.customer.fullName"
                        class="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        :placeholder="$t('full_name')"
                      />
                    </div>
                  </div>

                  <!-- Phone -->
                  <div class="space-y-1">
                    <label class="block text-sm font-medium text-gray-700">
                      {{$t('phone')}} *
                    </label>
                    <div class="relative">
                      <input
                        type="tel"
                        disabled
                        v-model="order.customer.phone"
                        class="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                  </div>
                </div>

                <!-- Address -->
                <div class="space-y-1">
                  <label class="block text-sm font-medium text-gray-700">
                    {{$t('adress')}} *
                  </label>
                  <div class="relative">
                    <textarea
                      disabled
                      v-model="order.customer.address"
                      rows="3"
                      class="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                      :placeholder="$t('adress')"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Action Buttons Section - Modern -->
        <div class="mt-8">
          <!-- Orders with shipping status -->
          <div v-if="order.shippings && order.shippings.status" class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <button @click="openModal('myModalReprogrammed')" 
                    class="flex items-center justify-center px-6 py-4 bg-gradient-to-r from-purple-600 to-purple-700 text-white font-semibold rounded-xl hover:from-purple-700 hover:to-purple-800 transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-purple-200 shadow-lg">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              {{ $t("reprogrammer") }}
            </button>
            
            <button @click="openModal('myModalUnreachable')" 
                    class="flex items-center justify-center px-6 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-xl hover:from-orange-600 hover:to-orange-700 transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-orange-200 shadow-lg">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
              </svg>
              {{ $t("unreachable") }}
            </button>
            
            <button @click="openModal('myModalCancelled')" 
                    class="flex items-center justify-center px-6 py-4 bg-gradient-to-r from-red-600 to-red-700 text-white font-semibold rounded-xl hover:from-red-700 hover:to-red-800 transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-red-200 shadow-lg">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
              {{ $t("cancelled_callcenter") }}
            </button>
          </div>

          <!-- Normal orders -->
          <div v-else>
            <!-- Main confirm button -->
            <div class="mb-4">
              <button @click="open('modal-confirm')" 
                      class="w-full flex items-center justify-center px-8 py-4 bg-gradient-to-r from-green-600 to-emerald-600 text-white text-lg font-semibold rounded-xl hover:from-green-700 hover:to-emerald-700 transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-green-200 shadow-lg">
                <svg class="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
                {{$t('confirm')}}
              </button>
            </div>
            
            <!-- Secondary action buttons -->
            <div class="grid grid-cols-2 lg:grid-cols-4 gap-4">
              <template v-if="currentUser && !order.isCancelled && (currentUser.type=='TeleConsultant' || currentUser.type=='ToRemind')">
                <button @click="$vm2.open('myModalUnrached')" 
                        class="flex items-center justify-center px-4 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-blue-200 shadow-md">
                  <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                  </svg>
                  {{$t('unreached')}}
                </button>
                
                <button @click="$vm2.open('myModalRemonded')" 
                        class="flex items-center justify-center px-4 py-3 bg-gradient-to-r from-purple-600 to-purple-700 text-white font-semibold rounded-lg hover:from-purple-700 hover:to-purple-800 transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-purple-200 shadow-md">
                  <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  {{$t('to_remind')}}
                </button>
              </template>
              
              <button @click="$vm2.open('myModalCancel')" 
                      class="flex items-center justify-center px-4 py-3 bg-gradient-to-r from-red-600 to-red-700 text-white font-semibold rounded-lg hover:from-red-700 hover:to-red-800 transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-red-200 shadow-md">
                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
                {{$t('cancelled_callcenter')}}
              </button>
              
              <button @click="$vm2.open('priceReductionModal')" 
                      class="flex items-center justify-center px-4 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-lg hover:from-orange-600 hover:to-orange-700 transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-orange-200 shadow-md">
                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"></path>
                </svg>
                Réduction de prix
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- All the existing modals remain the same but with modern styling updates -->
      <!-- Confirmation Modal - Modern -->
      <vue-modal-2 name="modal-confirm" :headerOptions="{title: $t('confirmation_order')}" :noFooter="true" modalSize="lg" @on-close="CloseModal('modal-confirm')">
              <div class="p-4 pt-0 relative">
               <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                  <div>
                      <div class="flex flex-col md:flex-row">

                        <!-- <p class="text-lg">
                          Maintenant c’est: <strong>{{ $f.getTimeOfDayLabel('') }}</strong>
                        </p> -->

                          <div class="w-1/2 mx-2 flex-1 svelte-1l8159u">
                           <label for="shipp-date" class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase"> {{$t('shipping_date')}} (*)</label>                 
                             <datetime-v2 :min-datetime="$moment(Date.now()).format('yyyy-MM-DD')" v-model="shipping.date"
                                       :placeholder="$t('shipping_date')" input-class="focus:outline-none shadow appearance-none border-2 border-gray-500 rounded w-full py-2 px-3 text-grey-darker" ></datetime-v2> 
                             
                          <!-- <label  class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase"> {{$t('zone')}} (*)</label>
                          <div  class="shadow bg-white my-2 p-1 flex border-2 border-gray-500 rounded svelte-1l8159u">
                                  <v-select label="name"  v-model="order.zone" :options="zones"></v-select>
                          </div> -->

                              <label  class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase"> {{$t('city')}} (*)</label>
                              <div  class="shadow bg-white my-2 p-1 flex border-2 border-gray-500 rounded svelte-1l8159u">
                                      <v-select  v-model="order.customer.city" :options="cities"></v-select>
                              </div>
                          </div>
                          <div class="w-1/2 mx-2 flex-1 svelte-1l8159u">
                             <label class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase">  {{$t('phone_2')}}</label>
                             <input type="tel"  :placeholder="$t('telephone')" v-model="order.customer.shippingPhone" class="shadow appearance-none border-2 border-gray-500 rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"> 
                              <label for="shipp-add" class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase"> {{$t('shipping_address')}} (*)</label>
                              <textarea id="shipp-add" v-model="order.customer.shippingAddress"  cols="10" rows="5" :placeholder="$t('shipping_address_hint')" class="my-2 p-1 shadow appearance-none border-2 border-gray-500 rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"></textarea> 
                          
                         <!-- <label class="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase"> {{$t('courier')}}</label>
                              <div class="shadow bg-white my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                  <v-select label="fullName" @search="searchCouriers($event,'hh')" v-model="shipping.courrier" :options="courier"></v-select>
                              </div>-->
                            
                          </div>
                      </div>
                <div class="w-full mx-2 flex-1 svelte-1l8159u">
                      <label class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase">{{$t('add_comment')}}</label>
                    <div class="velte-1l8159u" style="margin-right: 15px;">
                                  <textarea
                      id="commentConfirmation"
                      cols="10"
                      rows="3"
                      :placeholder="$t('comment_hint')"
                      v-model="order.comment"
                      class="my-2 p-1 shadow appearance-none border-2 border-gray-500 rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      ></textarea>
                    </div>
                  </div>
                  </div>
                  <div class="flex p-2 mt-4">
                      <div class="flex-auto flex flex-row-reverse">
                          <button @click="ConfirmOrderStatus(order)" :disabled="loading" class="w-1/6 p-3 rounded bg-green-600 hover:bg-green-500 text-white font-semibold focus:outline-none">{{$t('confirm')}}</button>
                      </div>
                  </div>
              </div>
         </vue-modal-2>

         
        <!-- ___________________________________________________________Debut section PopUp _________________ -->
      <!--Modal New courier Shipping -->
          <vue-modal-2  name="updateorders" :headerOptions="{title: 'Update order'}" :noFooter="true" modalSize="lg" @on-close="CloseModal('updateorders')">
            <div class="bg-white rounded-lg">
                <div class="rounded-lg flex">
                <div class="w-1/4 flex justify-center items-center">
                    <span class="w-16 h-16 bg-green-600 text-white p-3 rounded-full"><i class="material-icons" style="font-size: 40px;">update</i></span>
                </div>
                <div class="w-full pr-4 mt-4">
                  <div  v-for="(it, indx) in order.details" :key="indx" class="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4 mt-4">
                        <div class="grid grid-cols-1">
                          <div class="flex items-center maxx-heigh"><div class="flex-shrink-0 w-10 h-10"><img alt="..." :src="it.product.picture?it.product.picture:'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'" class="h-10 w-10 rounded-md mx-auto"></div><div class="ml-3"> {{it.product.name}} </div></div>
                        </div>
                        <div class="grid grid-cols-1">
                            <div class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                      <p>
                                          <label for="fullname" class="bg-white text-gray-700 px-1">{{$t('unit_price')}} <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup></label>
                                      </p>
                                  </div> 
                                  <p>
                                      <input type="number"  v-model="it.unitPrice" class="py-2 text-xs px-2 outline-none block h-full w-full"> 
                                  </p>
                              </div> 
                        </div>
                        <div class="grid grid-cols-1">
                              <div class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                      <p>
                                          <label for="Email" class="bg-white text-gray-700 px-1">{{$t('quantity')}}</label>
                                      </p>
                                  </div> 
                                  <p>
                                  <input type="number" v-model="it.quantity" class="py-2 text-xs px-2 outline-none block h-full w-full"> 
                                  </p>
                              </div> 
                        </div>
                  </div> 
                </div>
                </div>
                <div class="p-4 flex space-x-4">
                  <div @click="CloseModal('updateorders')" class="w-1/2 cursor-pointer px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">{{$t('cancel')}}</div>
                  <div @click="UpdateOrder('updateorders')" class="w-1/2 cursor-pointer px-4 py-3 text-center text-blue-100 bg-green-600 rounded-lg hover:bg-green-700 hover:text-white font-bold text-sm loidingconfirm relative" :class="loadingupdateorder?'noselect':''"><loading :active.sync="loadingupdateorder" :is-full-page="fullPage"></loading>{{$t('confirme')}}</div>
                </div>
            </div>
          </vue-modal-2>   
        <!-- ____________________________________Debut section PopUp Cancelled _______________ -->
          <vue-modal-2 name="myModalCancel" :headerOptions="{title: $t('cancelation_order')}" :noFooter="true" modalSize="lg" @on-close="CloseModal('myModalCancel')">
              <div class="relative flex flex-col w-full h-auto">
                <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                <!-- Header -->
              <!-- Modal Content-->
                <div class="bg-white rounded px-8 flex flex-col">
                  <div class="mb-3">
                  
                        <label class="block text-grey-darker text-sm font-bold mb-2" for="content">{{$t('reason_for_cancellation')}} <span :class="$colors.required">*</span></label>
                        <p>
                            <!-- <v-select  v-model="motifAnnulation" :options="comments"></v-select> -->
                            <textarea
                                id="content"
                                cols="10"
                                rows="3"
                                :placeholder="$t('content_hint')"
                                v-model="motifAnnulation"
                                class="focus:outline-none shadow appearance-none border border-gray-400 rounded w-full py-2 px-3 text-grey-darker mb-3"
                              ></textarea>
                        </p>     
                  
                    <div class="flex space-x-2">
                      <button
                        @click="cancelOrder(order)"
                        :disabled="loading"
                        class="w-full mt-2 bg-blue-600 focus:outline-none hover:bg-blue-500 text-white font-semibold p-3"
                      >
                        {{$t('cancel_order')}}
                      </button>
                    </div>
                  </div>
                </div>
                <!-- End of Modal Content-->
              </div>
          </vue-modal-2>
        <!-- ___________________________________________________________Debut section PopUp _________________ -->

          <!-- ____________________________________Debut section PopUp Remonded _______________ -->

        <vue-modal-2 name="myModalRemonded" :headerOptions="{title: $t('remonded_order')}" :noFooter="true" modalSize="lg" @on-close="CloseModal('myModalRemonded')">
         <div class="relative flex flex-col w-full h-auto">
            <loading :active.sync="loading" :is-full-page="fullPage"></loading>
            <!-- Header -->
            <!-- Modal Content-->
            <div class="bg-white rounded px-8 pt-6 pb-8 flex flex-col">
            <div class="mb-4">
              <label class="block text-grey-darker text-sm font-bold mb-2" for="dateremind">
                {{$t('remind_date')}} :
              </label>
              <!-- <input  v-model="remindDate" class="focus:outline-none shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker" id="dateremind" type="datetime-local" placeholder="date"> -->
             <datetime-v2 type="datetime" v-model="remindDate" :max-datetime="$moment(new Date()).add('days', 7).format()"
               :placeholder="$t('remind_date')" input-class="focus:outline-none shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker" ></datetime-v2>
            </div>
              <div class="mb-6">
                <label class="block text-grey-darker text-sm font-bold mb-2" for="content">{{$t('content')}}</label>
                  <textarea
                    id="content"
                    cols="10"
                    rows="3"
                    :placeholder="$t('content_hint')"
                    v-model="contentRemend"
                    class="focus:outline-none shadow appearance-none border border-red rounded w-full py-2 px-3 text-grey-darker mb-3"
                  ></textarea>
              </div>
              <div class="flex items-center justify-between">
                <button :disabled="loading" @click="RemindOrder(order)" class="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded" type="button">
                  {{$t('confirm')}}
                </button>
            </div>
            </div>
            <!-- End of Modal Content-->
          </div>
        </vue-modal-2>
        <!-- ___________________________________________________________Debut section PopUp _________________ -->
          <!-- ____________________________________Debut section PopUp Unrached ________________ -->

          <vue-modal-2 name="myModalUnrached" :headerOptions="{title: $t('unrached_order')}" :noFooter="true" modalSize="lg" @on-close="CloseModal('myModalUnrached')">
            <div class="flex flex-col w-full h-auto">
            <!-- Header -->
            <!-- Modal Content-->
            <div class="bg-white rounded px-8 pt-6 pb-8 flex flex-col">
               <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <div class="my-6">
                <div class="border seller-select h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="seller" class="bg-white text-gray-700 px-1"> {{$t('reason_unreached')}}
                          <span :class="$colors.required">*</span></label>
                        </p>
                    </div>    
                    <p>
                        <v-select  v-model="motifUnrached" :options="commentsUnrach"></v-select>
                    </p>     
                </div> 
              </div>
              <div class="flex items-center justify-between">
                <button :disabled="loading" @click="UnreachedOrder(order)" class="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded" type="button">
                 {{$t('confirm_unreached')}}
                </button>
            </div>
            </div>
            <!-- End of Modal Content-->
          </div>
          </vue-modal-2>

          <vue-modal-2 class="test"  name="ModalDouble" :headerOptions="{title: 'Double orders'}" :noFooter="true" modalSize="xl" @on-close="CloseModal('ModalDouble')">
            <div class="flex flex-col w-full h-auto p-5 pt-0  bottom_bitt">
                <div class="align-middle inline-block min-w-full overflow-hidden bg-white shadow-dashboard rounded-bl-lg rounded-br-lg" style="margin-bottom: 62px;">
                <table class="min-w-full">
                    <thead>
                        <tr>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left leading-4  text-green-600  tracking-wider">ID order</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">{{$t('customer')}}</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">{{$t('products')}}</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">{{$t('total_price')}}</th>
                             <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">{{$t('date')}}</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">{{$t('status')}}</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-right text-sm leading-4  text-green-600  tracking-wider">{{$t('action')}}</th>
                            
                        </tr>
                    </thead>
                        <tbody class="bg-white">
                        <tr v-for="(order,ind) in dataDouble" :key="ind">
                            <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="flex items-center">
                                    <div>
                                        <div class="text-sm leading-5 text-gray-800">{{order.id}}</div>
                                    </div>
                                </div>
                            </td>
                            <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="text-sm leading-5 siz12 text-blue-900">
                                  <div class="flex-grow-1">
                                    <h5 class="fs-14 mb-1">{{order.customer.fullName}}</h5>
                                    <p class="badge badge-soft-success text-uppercase">{{order.customer.phone}}</p></div>
                                  
                                </div>
                            </td>
                            <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="text-sm leading-5 text-blue-900">{{sumProduct(order.details)}}</div>
                            </td>
                            <td class="px-3 py-1 text-left border-t-2 border-gray-300 whitespace-no-wrap">
                                <div class="text-sm leading-5 text-blue-900">{{order.totalPrice}} <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup> </div>
                            </td>
                            <td class="px-3 py-1 text-left border-t-2 border-gray-300 whitespace-no-wrap">
                                <div class="text-sm leading-5 text-blue-900">{{$moment(order.date).format('yyyy-MM-DD') }}</div>
                            </td>
                             <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="text-sm leading-5 text-blue-900" v-bind:style="{color: order.status.name?order.status.color:'',borderColor: order.status.name?order.status.color:''}">{{order.status.name}}</div>
                            </td>
                            <td class="border-t-2 border-gray-300 px-3 py-1 text-right">
                              <router-link target="_blank" :to="{ path: `/orders/detail/${order._id}`}" class="text-sm leading-5 px-2 rounded-full text-xs text-blue-900 cursor-pointer font-medium"><i class="material-icons mx-2"> remove_red_eye</i></router-link>
                            </td>
                           
                        </tr>
                        </tbody> 
                    </table>
                            
            </div>     
                
            </div>

            <div class="modal-footer px-5 border0-t text-right">
                <button @click="CloseModal('ModalDouble')" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Cancel</button>
            </div>
          </vue-modal-2>    

          <vue-modal-2 name="warehouseParent" :headerOptions="{title: 'Choisir la ville de stockage'}" :noFooter="true" modalSize="md">
            <div class="flex flex-col w-full h-auto">
            <!-- Header -->
            <!-- Modal Content-->
            <div class="bg-white rounded px-2  pb-2 flex flex-col">
               <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                <p class="font-bold text-center">S'il vous plait Choisir la ville de stockage de produit</p>
                <div  class="shadow bg-white my-2 p-1  border-2 border-gray-500 rounded svelte-1l8159u">
                      <v-select  v-model="order.zone" :options="checkWraehouseParent" label="name"></v-select>
                </div>
                <div class="flex p-2 mt-4">
                      <div class="flex-auto flex flex-row-reverse">
                          <button :disabled="loading" @click="ConfirmOrderStatus(order,'warehouseParent')" class="w-1/3 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none"> {{$t('confirm')}}</button>
                          <button :disabled="loading"  @click="CloseModal('warehouseParent')" class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">Annuler</button>
                      </div>
                  </div>
            </div>
            <!-- End of Modal Content-->
          </div>
         </vue-modal-2>

          <!--Modal Up-Sells setting -->
        <vue-modal-2  name="upsell" :headerOptions="{title: `Product: ${upsell.product}`}" :noFooter="true" modalSize="lg" @onclose="close('upsell')">
            <div class="bg-white rounded-lg">
                <div class="bg-white px-8 mt-4 pb-1 mb-20">
                    <div class="vstack gap-2"> 
                        <div  v-for="(upsel, index) in upsell.upsells" :key="index" @click="activate(upsel)" :class="{active: upsell.activeUpsel && upsell.activeUpsel._id && upsell.activeUpsel._id.toString() === upsel._id.toString()?true:false}" class="form-check card-radio zoom-in intro-y">
                            <label class="form-check-label" for="listGroupRadioGrid1"> 
                                <div class="d-flex align-items-center">
                                    <div class="flex-shrink-0">
                                        <div class="avatar-xs">
                                            <div class="avatar-title bg-success-subtle text-success fs-18 rounded">
                                              <img class="h-8 w-8 rounded-full object-cover mx-1" src="https://img.icons8.com/stickers/100/sale-price-tag.png" alt="avatar">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-grow-1 ml-3">
                                        <h6 class="mb-1">Quantity: {{ upsel.quantity }}</h6>
                                        <b class="pay-amount">Prix: {{ upsel.price }} <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup></b>
                                    </div>
                                </div>
                            </label>
                        </div>
                     </div>
                </div>    
                <div class="modal-footer px-5 border0-t text-right">
                    <div  @click="CloseModal('upsell')" class="flex text-white cursor-pointer mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right" :class="loadingupdateorder?'noselect':''">Fermer</div>
                    <div @click="UpdateOrder('upsell')" class="flex text-white cursor-pointer mx-auto max-w-sm rounded text-center bg-green-500 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative mr-5" :class="loadingupdateorder?'noselect':''"><loading :active.sync="loadingupdateorder" :is-full-page="fullPage"></loading>Enregister Upsel</div>
                </div>
            </div>
        </vue-modal-2>  

         <!--  -->
         <vue-modal-2 ref="reprog" name="myModalReprogrammed" :headerOptions="{ title: $t('reprogrammer') }" :noFooter="true" modalSize="lg"  @on-close="CloseModal('myModalReprogrammed')">
            <!--  -->
            <div class="relative flex flex-col w-full h-auto">
              <!--  -->
              <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <!--  -->
              <div class="bg-white rounded px-8 flex flex-col">
                <!--  -->
                <div class="mb-3">
                  
                  <!--  -->
                  <label for="shipp-date" class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase"> {{ $t("shipping_date") }}</label>
                  <!--  -->

                  <!--  -->
                  <datetime-v2 :min-datetime="minDate" v-model="newShippingDate" :placeholder="$t('shipping_date')" type="datetime" input-class="focus:outline-none shadow appearance-none border-2 border-gray-500 rounded w-full py-2 px-3 text-grey-darker"></datetime-v2>
                  <!--  -->
                  
                  <!--  -->
                  <div class="flex space-x-2 mt-3 ">
                    <!--  -->
                    <button @click="ChangeShippingStatus(order, 'reprogrammer')" :disabled="loading" class="w-full mt-2 bg-blue-600 focus:outline-none rounded-md hover:bg-blue-500 text-white font-semibold p-3">
                      <!--  -->
                      {{ $t("confirm") }}
                      <!--  -->
                    </button>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </vue-modal-2>
          <!--  -->

            <!--  -->
          <vue-modal-2 name="myModalUnreachable" :headerOptions="{ title: $t('unreachable') }" :noFooter="true" modalSize="lg" @on-close="CloseModal('myModalUnreachable')">
            <!--  -->
            <div class="relative flex flex-col w-full h-auto">
              <!--  -->
              <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <!--  -->
              <div class="bg-white rounded px-8 flex flex-col">
                <!--  -->
                <div class="mb-3">
                  <!--  -->
                  <div class="flex flex-col gap-2 mb-5">
                    <!--  -->
                    <label for="shipp-date" class="font-bold h-6 text-gray-800 text-xs leading-8 uppercase">{{ $t('reason_unreached') }}</label>
                    <!--  -->

                    <!--  -->
                    <v-select class="focus:outline-none shadow appearance-none border-2 border-gray-500 rounded w-full py-1 px-3 text-grey-darker" v-model="motifUnrached" :options="commentsUnrach"></v-select>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="flex space-x-2 mt-3 ">
                    <!--  -->
                    <button @click="ChangeShippingStatus(order, 'unreachable')" :disabled="loading" class="w-full mt-2 bg-blue-600 focus:outline-none rounded-md hover:bg-blue-500 text-white font-semibold p-3">
                      <!--  -->
                      {{ $t("confirm") }}
                      <!--  -->
                    </button>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </vue-modal-2>
          <!--  -->

          <!--  -->
          <vue-modal-2 name="myModalCancelled" :headerOptions="{ title: $t('cancelled') }" :noFooter="true" modalSize="lg" @on-close="CloseModal('myModalCancelled')">
            <!--  -->
            <div class="relative flex flex-col w-full h-auto">
              <!--  -->
              <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <!--  -->
              <div class="bg-white rounded px-8 flex flex-col">
                <!--  -->
                <div class="mb-3">
                  <!--  -->
                  <div class="w-full flex-1 svelte-1l8159u">
                    <!--  -->
                    <label class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase">
                      <!--  -->
                      {{ $t('reason_for_cancellation') }}
                      <!--  -->
                    </label>
                    <!--  -->
                    <div class="velte-1l8159u">
                      <!--  -->
                      <textarea id="commentCancelled" cols="10" rows="3" :placeholder="$t('comment_hint')" v-model="shipping.comment" class="my-2 p-1 shadow appearance-none border-2 border-gray-500 rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"></textarea>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="flex space-x-2 mt-3">
                    <!--  -->
                    <button @click="ChangeShippingStatus(order, 'cancelled')" :disabled="loading" class="w-full mt-2 bg-blue-600 focus:outline-none rounded-md hover:bg-blue-500 text-white font-semibold p-3">
                      <!--  -->
                      {{ $t("confirm") }}
                      <!--  -->
                    </button>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </vue-modal-2>
          <!--  -->

           <!-- NEW: Price Reduction Modal -->
        <vue-modal-2 name="priceReductionModal" :headerOptions="{title: 'Demande de réduction de prix'}" :noFooter="true" modalSize="lg" @on-close="CloseModal('priceReductionModal')">
          <div class="relative flex flex-col w-full h-auto">
            <loading :active.sync="loadingPriceReduction" :is-full-page="fullPage"></loading>
            
            <div class="bg-white rounded px-8 pt-6 pb-8 flex flex-col">
              <!-- Current Price Display -->
              <div class="mb-4 p-4 bg-gray-100 rounded-lg">
                <h6 class="text-lg font-semibold mb-2">Prix actuel de la commande</h6>
                <div class="text-2xl font-bold text-blue-600">
                  {{ order.totalPrice }} <sup v-if="idWharhouse">{{ idWharhouse.currency }}</sup>
                </div>
              </div>

              <!-- New Price Input -->
              <div class="mb-4">
                <label class="block text-grey-darker text-sm font-bold mb-2" for="newPrice">
                  Nouveau prix proposé <span class="text-red-500">*</span>
                </label>
                <input
                  id="newPrice"
                  type="number"
                  step="0.01"
                  :placeholder="`Prix en ${idWharhouse.currency || 'MAD'}`"
                  v-model="priceReductionForm.proposedPrice"
                  class="focus:outline-none shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker"
                  :class="{'border-red-500': priceReductionErrors.proposedPrice}"
                />
                <p v-if="priceReductionErrors.proposedPrice" class="text-red-500 text-xs mt-1">
                  {{ priceReductionErrors.proposedPrice }}
                </p>
              </div>

              <!-- Reduction Percentage Display -->
              <div v-if="priceReductionForm.proposedPrice && priceReductionForm.proposedPrice < order.totalPrice" 
                   class="mb-4 p-3 bg-green-100 rounded-lg">
                <p class="text-green-800">
                  <strong>Réduction:</strong> {{ calculateReductionPercentage() }}% 
                  ({{ (order.totalPrice - priceReductionForm.proposedPrice).toFixed(2) }} {{ idWharhouse.currency }})
                </p>
              </div>

              <!-- Reason Input -->
              <div class="mb-6">
                <label class="block text-grey-darker text-sm font-bold mb-2" for="reductionReason">
                  Raison de la réduction <span class="text-red-500">*</span>
                </label>
                <textarea
                  id="reductionReason"
                  rows="4"
                  placeholder="Expliquez pourquoi vous demandez cette réduction (ex: client trouve le prix trop élevé, concurrent moins cher, etc.)"
                  v-model="priceReductionForm.reductionReason"
                  class="focus:outline-none shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker"
                  :class="{'border-red-500': priceReductionErrors.reductionReason}"
                ></textarea>
                <p v-if="priceReductionErrors.reductionReason" class="text-red-500 text-xs mt-1">
                  {{ priceReductionErrors.reductionReason }}
                </p>
              </div>

              <!-- Action Buttons -->
              <div class="flex items-center justify-between">
                <button 
                  @click="CloseModal('priceReductionModal')"
                  class="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded"
                  :disabled="loadingPriceReduction"
                >
                  Annuler
                </button>
                <button 
                  @click="submitPriceReduction"
                  :disabled="loadingPriceReduction"
                  class="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded"
                >
                  Envoyer la demande
                </button>
              </div>
            </div>
          </div>
        </vue-modal-2>

      <!-- Keep all other modals with similar modern styling updates... -->
      <!-- For brevity, I'm showing the structure but you would apply similar modern styling to all modals -->
      
    </div>
  </div>
</template>

<script>
 var Timer = require("easytimer.js").Timer; 
 var timer = new Timer();
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object},
     sous_idWharhouse: { type: String},
     sous_warehouses: { type: Array },
   },
  data() {
    return {
      formData: {
        customer: {},
        details: [],
        seller: {},
      },
      zones: [],
      courier: [],
      loading:false,
      fullPage: false,
      couriers:[],
      shipping: {
        date: "",
        zone: null,
        courrier: null,
      },
      limit: 10,
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
      statusOrder: [],
     // currentUser: {},
      order: [{
        customer: {},
        details: [],
        seller: {},
        teleConsultant: {},
        skippedBy: [],
        unreachedBy: [],
      }],
      showButtonStart: true,
      vShow: false,
      orderFound:false,
      finished: false,
      isEditing: false,
      style: false,
      edit: true,
      sec: 0,
      min: 0,
      hr: 0,
      passedTime: "",
      time:0,
      m: 0,
      s: 0,
      h: 0,
      dateDebut: "",
      cities:[],
      zeroH: false,
      zeroM: false,
      zeroS: false,
      motifAnnulation: "",
      motifUnrached:"",
      contentRemend:"",
      currency:"",
      remindDate:null,
      loadingupdateorder:false,
      dataCountry: this.$countries,
      comments:['Not interested-changed mind',"Didn't order","Fake phone number","Too expensive","Non delivery area","Out of country","Mistake","Bad comments","Multiple order"],
      commentsUnrach:["Boite vocale","Ne répond pas","Or ligne"],
      //idWharhouse:null,
      loadingDouble:false,
      dataDouble:[],
      checkWraehouseParent:[],
      upsell:{product:"",upsells:[],activeUpsel:{}},
      statusCancelled:null,
      newShippingDate: this.getCurrentDate(),
      minDate: this.getCurrentDate(),
      // NEW: Price Reduction Properties
      loadingPriceReduction: false,
      priceReductionForm: {
        proposedPrice: null,
        reductionReason: ''
      },
      priceReductionErrors: {
        proposedPrice: null,
        reductionReason: null
      },

    };
  },
  async mounted() {
    //await this.getUser();
    this.token = this.$jwtService.verifyToken();
    if(this.currentUser && (this.currentUser.type != 'TeleConsultant' && this.currentUser.type != 'NRP' && this.currentUser.type != 'CancelledOrder' && this.currentUser.type != 'ToRemind')) this.$router.back();
    this.statusCancelled=await this.getStatusByName("Cancelled");
    console.log('sous_warehouses -------',this.sous_warehouses)
    //await this.getwharhouseId();
   // await this.getStatus();
     await this.getZones();
    // await this.getCouriers();

    const { id: paramsOrderId } = this.$route.params;
    if(paramsOrderId) {
      console.log('paramsOrderId------',paramsOrderId)
      this.startConfirmation(paramsOrderId);
    }
    

   
  },
  computed: {
      warhouseSelected(){
           return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['countries'])})
      },
   },
   watch: {
      'warhouseSelected': async function(oldVal, newVal) {
        // await this.getwharhouseId();
        
      },
      'idWharhouse': async function(oldVal, newVal) {
            this.idWharhouse=oldVal;  
            await this.getZones();
            //await this.getCouriers();  
      }
  },
  methods: {
    // NEW: Price Reduction Methods
    calculateReductionPercentage() {
      if (!this.priceReductionForm.proposedPrice || !this.order.totalPrice) return 0;
      const reduction = ((this.order.totalPrice - this.priceReductionForm.proposedPrice) / this.order.totalPrice) * 100;
      return Math.round(reduction * 100) / 100;
    },

    validatePriceReduction() {
      this.priceReductionErrors = {
        proposedPrice: null,
        reductionReason: null
      };

      let isValid = true;

      // Validate proposed price
      if (!this.priceReductionForm.proposedPrice) {
        this.priceReductionErrors.proposedPrice = "Le nouveau prix est requis";
        isValid = false;
      } else if (this.priceReductionForm.proposedPrice <= 0) {
        this.priceReductionErrors.proposedPrice = "Le prix doit être supérieur à 0";
        isValid = false;
      } else if (this.priceReductionForm.proposedPrice >= this.order.totalPrice) {
        this.priceReductionErrors.proposedPrice = "Le nouveau prix doit être inférieur au prix actuel";
        isValid = false;
      }

      // Validate reason
      if (!this.priceReductionForm.reductionReason.trim()) {
        this.priceReductionErrors.reductionReason = "La raison est requise";
        isValid = false;
      } else if (this.priceReductionForm.reductionReason.trim().length < 10) {
        this.priceReductionErrors.reductionReason = "Veuillez fournir une raison plus détaillée (min 10 caractères)";
        isValid = false;
      }

      return isValid;
    },

    async submitPriceReduction() {
      if (!this.validatePriceReduction()) {
        return;
      }

      try {
        this.loadingPriceReduction = true;

        const priceReductionData = {
          _id: this.order._id,
          priceReduction: {
            originalPrice: this.order.totalPrice,
            proposedPrice: this.priceReductionForm.proposedPrice,
            reductionReason: this.priceReductionForm.reductionReason,
            teleConsultant: this.currentUser._id,
            teleConsultantName: this.currentUser.fullName || this.currentUser.email,
            proposedAt: new Date(),
            status: 'en attente'
          },
          teleConsultant: null,
          requestPriceReduction: true // Flag for backend to handle this request
        };

        const response = await this.$server.update("orders", priceReductionData);
        
        if (response && response._id) {
          this.$alert("Demande de réduction envoyée avec succès! En attente d'approbation.", "success");
          this.CloseModal('priceReductionModal');
          
          // Reset form
          this.priceReductionForm = {
            proposedPrice: null,
            reductionReason: ''
          };
          
          // Refresh order data
          await this.refreshOrderData();
        } else {
          throw new Error(response.message || "Erreur lors de l'envoi de la demande");
        }
      } catch (error) {
        console.error("Error submitting price reduction:", error);
        this.$alert(error.message || "Erreur lors de l'envoi de la demande", "error");
      } finally {
        this.loadingPriceReduction = false;
      }
    },
    async refreshOrderData() {
      try {
        const refreshedOrder = await this.$server.get("orders", {
          id: this.order._id,
          getCurrentOrder: true
        });
        if (refreshedOrder && refreshedOrder.content) {
          // Update order while preserving reactive properties
          Object.assign(this.order, refreshedOrder.content);
          this.refreshData("Order updated", "success");
        }
      } catch (error) {
        console.error("Error refreshing order data:", error);
      }
    },
    async ChangeShippingStatus(data, status) {
      try {
        const confirmed = await this.$confirm(`Etes-vous sûr de vouloir modifier le statut de la commande en ${status}?`);
        if (!confirmed) return;

        this.loading = true;

        const dataRepro = { status, _id: data._id };

        if (status === 'unreachable') {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          tomorrow.setHours(7, 32, 0, 0);
          dataRepro.date = tomorrow;
        } else if (['reprogrammer'].includes(status)) {
          dataRepro.date = this.newShippingDate || this.shipping.date;
        } else if (status === 'cancelled') {
          dataRepro.comment = this.shipping.comment || '';
        }

        // Call API to change status
        const change = await this.$server.changeReprogrammedStatus("orders", dataRepro);

        if (change) {
          this.$alert(this.$t("Order updated"), "success");
          this.refreshData("Order updated", "success");
        }
      } catch (error) {
        console.error("Error in ChangeShippingStatus:", error);
        this.$alert(this.$t("Failed to update order"), "error");
      } finally {
        this.newShippingDate = this.getCurrentDate();
        this.loading = false;
      }
  },
  getCurrentDate() {
      return this.$moment().utcOffset(60).format('YYYY-MM-DDTHH:mm');
  },
  checkUpselExist(product){
    let upselExist=false
    const checkUpsel=product.details.find(item => item.warehouse && item.warehouse && item.warehouse.toString() === this.idWharhouse._id.toString())
    if(checkUpsel && checkUpsel.upsells && checkUpsel.upsells.length>0){
      upselExist=checkUpsel.upsells;
    } 
    return upselExist;
  },
   async CloseModal(id){
     if(this.loading || this.loadingPriceReduction) return;
      this.$vm2.close(id);

      // Reset price reduction form when closing modal
      if (id === 'priceReductionModal') {
        this.priceReductionForm = {
          proposedPrice: null,
          reductionReason: ''
        };
        this.priceReductionErrors = {
          proposedPrice: null,
          reductionReason: null
        };
      }

      this.upsell={product:"",upsells:[],activeUpsel:{}}
      if(id === 'updateorders'){
         const editData = await this.$server.get("orders", {id: this.order._id,getCurrentOrder:true});
         this.order.details=editData.content.details;
      }
    },
    async openModal(id,product=null,upsells=[]){
        if(id === 'upsell'){
          this.upsell={product:product,upsells:upsells,activeUpsel:{}}
        } 
        this.$vm2.open(id);
    },
    activate(upsel){
      console.log('this==============>',upsel)
      this.upsell.activeUpsel=upsel;
      console.log("activate activeUpsel --------", this.upsell.activeUpsel)
    },
    sumProduct(data){
      let product="";
      for (let i in data) {
        if(data[i].product && data[i].product.name) product+=data[i].product.name
        if(data.length-1 != i) product+=" ,"; 
      }
      return product;
    },
    async getwharhouseId(){
        await this.$store.dispatch('wharhouse/getwharhouseId',{country:await this.warhouseSelected}).then((res) => {
                this.idWharhouse=res;
            })
    },
    async getCurrency(){
        await this.$store.dispatch('wharhouse/getCurrency').then((res) => {
                this.currency=res;
            })
    },
    SumTotalPrice(data) {
       let total=0;
        for (let i in data) {
          total += data[i].quantity * data[i].unitPrice;
        }
        return total;
    },
   async UpdateOrder(name=null){
    console.log('order 11-------', this.order.details)
      if(name && name === 'upsell'){
          if(!this.upsell.activeUpsel._id){this.$toast.warning("SVP choisir un Pack Upsell");return false;} 
          const index = this.order.details.findIndex(obj => {return obj.product.details.find(item => item.warehouse && item.warehouse && item.warehouse.toString() === this.idWharhouse._id.toString()).upsells.find(el => el._id.toString() === this.upsell.activeUpsel._id.toString())._id.toString() === this.upsell.activeUpsel._id.toString()});
          console.log('index-------',index)
          this.order.details[index].unitPrice=this.upsell.activeUpsel.price/this.upsell.activeUpsel.quantity;
          this.order.details[index].quantity=this.upsell.activeUpsel.quantity;
      }

      for (let index = 0; index < this.order.details.length; index++) {
            const orderLine = this.order.details[index];
            const product = await this.$server.get("products",{  _id: orderLine.product._id } )
            const dataWhrahouse= this.getElementInArray(product.content.details,this.idWharhouse._id);
            if (dataWhrahouse.outOfStock || dataWhrahouse.quantity.inStock < orderLine.quantity) {
                return  this.$toast.warning(`Quantité en stock insuffisante pour ce produit: (${product.content.name}),(Stock disponible: ${dataWhrahouse.quantity.inStock})`);
                break;
            }
      }
      this.loadingupdateorder=true;
      this.order.totalPrice=this.SumTotalPrice(this.order.details);
      const resUpp= await this.$server.update("orders", this.order);
      this.loadingupdateorder=false;
      if(resUpp && resUpp._id) {alert(this.$t('order_updated'), "success");this.$vm2.close(name);this.upsell={product:"",upsells:[],activeUpsel:{}}} 
      else alert(resUpp, "warning"); 
    },
    getElementInArray(data,value){
      var result  = data.filter(function(o){
          let warhouse=o.warehouse;
          if(o.warehouse._id) warhouse=o.warehouse._id;
          
          return warhouse == value.toString();
      } );
      return result? result[0] : null; // or undefined
    },
    async getCities(country){
      const resCities = await this.$server.get("zones", { allCities: true,country:country}); 
      if(resCities && resCities.content.length>0)  this.cities= resCities.content;
      else this.cities=[];
    },
    dateMin(){ 
       //document.getElementById('shippdate').setAttribute('min', this.$moment(Date.now()).format('yyyy-MM-DD')); 
    },
    CalculateTime() {
      // this.passedTime =this.hr + "hr " + ":" + this.min + " min" + ": " + this.sec + "sec";
      // this.time=this.hr*3600 +  this.min*60 + this.sec;
      // clearTimeout(this.h);
      // clearTimeout(this.m);
      // clearTimeout(this.s);
      this.passedTime=timer.getTimeValues().toString();
    },
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    async open(name){
       this.$vm2.open(name);
       if(name== 'modal-confirm') await this.getCities(this.order.customer.country);
    },
    async assign(data) {
      const nDate = new Date().toLocaleString('en-US', {timeZone: 'Africa/Casablanca'});
       let newdate=new Date(nDate)
     // if(!data.teleConsultant) {
        data.teleConsultant = this.currentUser._id;
        data.startDate=newdate;
        data.updateStartDate=true;
        data.updateTeleConsultant=true;
        await this.$server.update("orders", data);
        delete data.updateTeleConsultant;
     // }
    },
    async getOrderDoubled(country,phone,seller,product,id){
      this.loadingDouble=true;
      const data = await this.$server.search("orders",{'details.product':product,'customer.country':country,phone:phone,_id:id,seller:seller,limit:10});
      this.loadingDouble=false;
      if(data && data.content && data.content.results) this.dataDouble=data.content.results;
      else this.dataDouble=[]
      console.log('data-------',data)
    },
    async startConfirmation(orderId = null) {
      console.log('startConfirmation orderId----',orderId)
      this.upsell={product:"",upsells:[],activeUpsel:{}}
      const country= await this.warhouseSelected;
      await this.getOrder(country,orderId);
      
       console.log("HIIII JE SUIS this.order", this.order);
       console.log("warehouse", this.idWharhouse);
      
      if (this.orderFound) {
       
       // await this.assign(this.order);

        timer.reset();
        timer.start();

        timer.addEventListener('secondsUpdated', function (e) {
            $('#gettingValuesExample .hours').html(('0' + timer.getTimeValues().hours).slice(-2));
            $('#gettingValuesExample .minutes').html(('0' + timer.getTimeValues().minutes).slice(-2));
            $('#gettingValuesExample .seconds').html(('0' + timer.getTimeValues().seconds).slice(-2));
        });

         document.body.style.overflow = 'inherit'

        this.showButtonStart = false;
        this.sec = 0;
        this.min = 0;
        this.hr = 0;
        const nDate = new Date().toLocaleString('en-US', {timeZone: 'Africa/Casablanca'});
        let newdate=new Date(nDate)
        this.dateDebut = new Date();
        await this.getOrderDoubled(country,this.order.customer.phone,this.order.seller._id,this.order.details[0].product._id,this.order._id);

      } else  alert(this.$t('no_order_to_confirm'), "warning");
    },
    async getOrder(country,orderId) {
      console.log('---------------getOrder-------------',orderId)

        let data = null;
        this.loading=true;
        // Min: 1s, Max: 3s, Steps: 0.5s
        const minDelay = 700;
        const maxDelay = 2500;
        const stepSize = 400; // 0.5s
        
        const steps = (maxDelay - minDelay) / stepSize + 1; // 5 خطوات
        const randomStep = Math.floor(Math.random() * steps);
        const randomDelay = minDelay + (randomStep * stepSize);
      
        console.log(`Waiting for ${randomDelay} ms before starting confirmation...`);
        await new Promise(resolve => setTimeout(resolve, randomDelay));
        console.log("Starting confirmation...");

        data = orderId
          ? await this.$server.get("orders", { id: orderId,Confirmation:true })
          : await this.$server.confirmation("orders", { country:country })
        this.loading=false;

      //console.log('data getOrder____________',data.shippings)
      if (data && data.content && typeof data.content !== "undefined") {
        this.orderFound=true;
        this.order = data.content;
        const validatePhone = await this.$f.normalizePhone(this.order.customer.phone, this.idWharhouse.country);
        console.log('validatePhone-------',validatePhone)
        this.order.customer.phone = validatePhone ? validatePhone.e164.replace(/^\+/, '') : this.order.customer.phone;
        this.order.date=this.$moment(this.order.date).format('yyyy-MM-DD HH:mm');
        this.order.customer.city = null;
        if(this.order.status._id.toString() === this.statusCancelled._id.toString())  this.order.isCancelled=true;
        else this.order.isCancelled=null;

      } else {
        this.order=[{
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          skippedBy: [],
          unreachedBy: [],
      }],
        this.orderFound=false;
        this.finished = true;
      }
    },
    //****************************** Zones  ***********************************/
    async getZones() {
      const res = await this.$server.search("zones",{limit:2000,country: this.idWharhouse.country});
      if (res && res.content.results) this.zones = res.content.results;
      else this.zones = [];
    },
     async getCouriers() {
        const filter = {
          type: "Courier",
          countries: await this.warhouseSelected,
          limit:this.limit
        };
        const res = await this.$server.search("users", filter);
        if (res.content.results) {
          this.courier = res.content.results;
        } else this.courier = [];
    },
    searchCouriers: _.debounce(async function(search) {
        const filter = {
            type: "Courier",
            limit:this.limit,
            countries:await this.warhouseSelected,
            name: search,
            };  
            const res= await this.$server.find("users",filter);   
        if (res.content.results) this.courier = res.content.results;
        else this.courier = [];
    }, 500),
    async getCourierZone(zone) {
      // if(zone){
      //   const filter = {
      //     type: "Courier",
      //     countries: await this.warhouseSelected,
      //     zones: zone._id,
      //     limit:10
      //   };
      //   const res = await this.$server.search("users", filter);
      //   if (res.content.results) {
      //     this.courier = res.content.results;
      //   } else this.courier = [];
      // }
    },
    // **************************************************************************
    async getStatus() {
      const res = await this.$server.search("status");
      if (res.content.results) this.statusOrder = res.content.results;
      else this.statusOrder = [];
    },
    async getStatusByName(name) {
        const result = await this.$server.get("status",{  name: name  });
        return result.content;
    },
    async getStatusId(status) {
      for (let i in this.statusOrder) {
        if (this.statusOrder[i].name == status) {
          return this.statusOrder[i]._id;
        }
      }
    },

    CreateShipping() {
      const data = {
        address: this.order.customer.shippingAddress,
        date: this.shipping.date,
        order: this.order._id,
      };
      //console.log("HIIIIIIIIIIIIIIII SE SUIS data", data);
      // const data = await this.$server.create("status", this.formData);
    },

    async ConfirmOrderStatus(dataToEdit,checkParent=null) {
      console.log('sous_warehouses -------',this.sous_warehouses)
     // return false;
     this.loading=true;
     if(!checkParent){
       this.checkWraehouseParent=[];
       //check stock if exist
       if(this.sous_warehouses.length>0){

          for (let index = 0; index < dataToEdit.details.length; index++) {
              const orderLine = dataToEdit.details[index];
              // orderLine.warehouseParent=this.idWharhouse._id;
              // orderLine.warehouseParentName=this.idWharhouse.name;
              const {content:product} = await this.$server.get("products",{  _id: orderLine.product._id } )
              //console.log('product -------',product)
              let dataWhrahouse=this.$f.getElementInArrayByCountry(product.details,this.idWharhouse.country,orderLine.quantity);
              if(dataWhrahouse && dataWhrahouse.length>0){
                 this.checkWraehouseParent=dataWhrahouse.map(i => i.warehouse);
                 if(this.checkWraehouseParent.length == 1){
                    orderLine.warehouseParent=this.checkWraehouseParent[0]._id;
                    orderLine.warehouseParentName=this.checkWraehouseParent[0].name;
                 }
              }else this.checkWraehouseParent=[] 
          }
       }

      //  if(this.checkWraehouseParent.length>1){
      //     this.loading=false;
      //     this.$vm2.open('warehouseParent');
      //     return false
      //  }

     }


      
      // if(checkParent && !dataToEdit.zone){
      //     this.loading=false;
      //     alert('Ville de stockage required', "warning");
      //     return false
      // }
      // if(checkParent && dataToEdit.zone){
      //   for (let index = 0; index < dataToEdit.details.length; index++) {
      //         const orderLine = dataToEdit.details[index];
      //         orderLine.warehouseParent=dataToEdit.zone._id;
      //         orderLine.warehouseParentName=dataToEdit.zone.name;
      //   }
      // }
       //console.log('checkWraehouseParent -------',this.checkWraehouseParent)
       console.log('dataToEdit -------',dataToEdit)
       
     //return false;
      
      this.dateMin();
      let id = await this.getStatusByName("Confirmed");
      console.log('id_______',id);
      // console.log('status______',await this.$server.get("status"))
      dataToEdit.status = id;
      dataToEdit.statusCallcenter = id;
      this.CalculateTime();
      dataToEdit.timeConsumed = this.passedTime;
      dataToEdit.time = parseInt(this.time);
      dataToEdit.dateDebut = this.dateDebut;
      dataToEdit.teleConsultantConfirm = this.currentUser._id;

      if (
        this.shipping.date &&
        this.order._id &&
        this.order.customer.city
      ) {
        const datashipping = {
          address: this.order.customer.shippingAddress,
          country: this.order.customer.country,
          date: this.shipping.date,
          order: this.order._id,
          seller: this.order.seller._id,
          totalPrice:this.order.totalPrice,
         // zone: this.order.zone._id || this.order.zone,
          //courier: this.shipping.courrier._id,
          status: "to prepare"
      };
        dataToEdit.shipping = datashipping;
       
        console.log('dataToEdit_______',dataToEdit);
        dataToEdit.Confirmation=true;
        const data = await this.$server.update("orders", dataToEdit);
        this.loading=false;
        if (data && data._id) {
          this.$vm2.close('warehouseParent');
          alert(this.$t('order_confirmed'), "success");
           dataToEdit={};
          this.order = {
            customer: {},
            details: [],
            seller: {},
            teleConsultant: {},
            skippedBy: [],
          };
          this.shipping={}
          this.showButtonStart = true;
          this.vShow = true;
        }else{
          await this.$server.update("orders", {_id: this.order._id,teleConsultant:null,onlyCommentedit:true});  
          // let BodyDataOrder={_id: this.order._id,teleConsultant:null};
          //  if(dataOrr.message_1 && dataOrr.action && dataOrr.action=='Confirmation'){
          //     BodyDataOrder.warehouse=dataOrr.warehouse;
          //     BodyDataOrder.productId=dataOrr.productId;
          //     BodyDataOrder.ChangeToWaiting=true;
          //     BodyDataOrder.quantity=dataOrr.quantity;
          //  } 
          //   await this.$server.update("orders", BodyDataOrder); 
          this.refreshData(data.message_1||data, "warning")
        } 
      } else {
        this.loading=false;
        return alert(this.$t('all_required_field'), "warning");
      }
    },
     async OrangeOrderStatus(dataToEdit) {
     
      this.$confirm("Êtes-vous sûr de vouloir modifier l'ordre d'attente des paiements ?").then(async (res) => {
          if (res) {
            let id = await this.getStatusByName("Orange money");
            dataToEdit.status = id;
            dataToEdit.statusCallcenter = id;
            this.CalculateTime();
            dataToEdit.timeConsumed = this.passedTime;
            dataToEdit.time = parseInt(this.time);
            dataToEdit.dateDebut = this.dateDebut;
            dataToEdit.teleConsultantConfirm = this.currentUser._id;
            dataToEdit.transfer = true;
            const data = await this.$server.update("orders", dataToEdit);
            if (data && data._id) {
               this.refreshData('Order updated', "success")
            }else{
              await this.$server.update("orders", {_id: this.order._id,teleConsultant:null,onlyCommentedit:true});  
              this.refreshData(data, "warning");
            }  
          }
        });
    },
   async RemindOrder(dataToEdit){
      this.loading=true;
      dataToEdit.comment=this.contentRemend;
      
      dataToEdit.remind=this.remindDate;
      this.CalculateTime();
      dataToEdit.timeConsumed = this.passedTime;
      dataToEdit.time = parseInt(this.time);
      dataToEdit.dateDebut = this.dateDebut;
      const element = {
        user: this.currentUser._id,
      };

      dataToEdit.remindBy.push(element);
      dataToEdit.teleConsultant = null;
      dataToEdit.reminded = true;
      dataToEdit.lastUnreachedDate = null;
      if (!this.remindDate) {
        alert(this.$t('reminder_date_empty'), "warning");
        this.loading=false;
        return false;
      }

      
       console.log('date____', dataToEdit.remind)
      const data = await this.$server.update("orders", dataToEdit);
      this.loading=false;
      if (data && data._id) {
        alert(this.$t('order_reminded'), "success");
        this.remindDate=null;
        this.contentRemend="";
        dataToEdit={};
        this.order = {
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          remindBy: [],
          unreachedBy: [],
        };
        this.showButtonStart = true;
        this.vShow = true;
      }else{
      await this.$server.update("orders", {_id: this.order._id,teleConsultant:null,onlyCommentedit:true});  
        dataToEdit={};
        this.remindDate=null;
        this.contentRemend="";
        this.order = {
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          remindBy: [],
          unreachedBy: [],
        };
        this.showButtonStart = true;
        this.vShow = true;
        alert(data, "warning");
      }
    },
    async skipOrder(dataToEdit) {
      let id = await this.getStatusByName("Skipped");
      const element = {
        user: this.currentUser._id,
      };

      dataToEdit.skippedBy.push(element);
      dataToEdit.skiped = id;
      dataToEdit.teleConsultant = null;

      this.$confirm(this.$t('skip_order')).then(async (res) => {
        if (res) {
          this.CalculateTime();
          dataToEdit.timeConsumed = this.passedTime;
          dataToEdit.time = parseInt(this.time);
           dataToEdit.teleConsultantConfirm = this.currentUser._id;
          dataToEdit.dateDebut = this.dateDebut;
          const data = await this.$server.update("orders", dataToEdit);
          if (data._id) {
            alert(this.$t('order_skipped'), "warning");
            this.order = {
              customer: {},
              details: [],
              seller: {},
              teleConsultant: {},
              skippedBy: [],
              unreachedBy: [],
            };
            this.showButtonStart = true;
            this.vShow = true;
          }
        }
      });
    },
    /************************************************* */
    async cancelOrder(dataToEdit) {
       this.loading=true;
       const nDate = new Date().toLocaleString('en-US', {timeZone: 'Africa/Casablanca'});
       let newdate=new Date(nDate)
       let id =  await this.getStatusByName("Cancelled");

      if(dataToEdit.isCancelled) dataToEdit.validated_status=new Date();

      dataToEdit.status = id;
      dataToEdit.statusCallcenter = id;
      dataToEdit.motifAnnulation = this.motifAnnulation;
      this.CalculateTime(); 
      dataToEdit.timeConsumed = this.passedTime;
      dataToEdit.time = parseInt(this.time);
      dataToEdit.teleConsultantConfirm = this.currentUser._id;
      dataToEdit.dateDebut = this.dateDebut;
      dataToEdit.comment=this.motifAnnulation; 
      dataToEdit.teleConsultant = null;

      if(!this.motifAnnulation){
        this.loading=false;
          alert(this.$t('reason_cancelled_required'), "warning");
          return false
      }
       
       dataToEdit.cancelOrder=true;
      const data = await this.$server.update("orders", dataToEdit);
      this.loading=false;
      if (data && data._id) {
        this.motifAnnulation="";
        alert(this.$t('order_cancelled'), "success");
         dataToEdit={};
        this.order = {
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          skippedBy: [],
          unreachedBy: [],
        };
        this.showButtonStart = true;
        this.vShow = true;
      }else {
        await this.$server.update("orders", {_id: this.order._id,teleConsultant:null,onlyCommentedit:true});  
        alert(data,'warning')
      }
    },

    /************************************************************/

   async UnreachedOrder(dataToEdit) {
          this.loading=true;
          let id =  await this.getStatusByName("Unreached");
          const nDate = new Date().toLocaleString('en-US', {timeZone: 'Africa/Casablanca'});
          let newdate=new Date(nDate)
          dataToEdit.unreached = id;
          dataToEdit.teleConsultant = null;
          dataToEdit.lastUnreachedDate = newdate;

          if(dataToEdit.remind){
             // dataToEdit.isReminded=true;
              dataToEdit.remind=null;
              dataToEdit.isReminded=false;
          }
          this.CalculateTime();
          dataToEdit.timeConsumed = this.passedTime;
          dataToEdit.time = parseInt(this.time);
          dataToEdit.dateDebut = this.dateDebut;
          dataToEdit.comment=this.motifUnrached;
          dataToEdit.dateUnrash = newdate;

          delete dataToEdit.updateStartDate;

          if(!this.motifUnrached){
            this.loading=false;
             alert(this.$t('reason_unreached_required'), "warning");
             return false
          }

         

          const data = await this.$server.update("orders", dataToEdit);
          this.loading=false;
          if (data && data._id) {
            alert(this.$t('order_unreached'), "success");
            this.motifUnrached="";
            this.order = {
              customer: {},
              details: [],
              seller: {},
              teleConsultant: {},
              skippedBy: [],
              unreachedBy: [],
            };
            this.showButtonStart = true;
            this.vShow = true;
          }else{
            await this.$server.update("orders", {_id: this.order._id,teleConsultant:null,onlyCommentedit:true});  
            alert(data,"warning");
            this.motifUnrached="";
            this.order = {
              customer: {},
              details: [],
              seller: {},
              teleConsultant: {},
              skippedBy: [],
              unreachedBy: [],
            };
            this.showButtonStart = true;
            this.vShow = true;
            }
      
    },
    /****************** Edit Information **********************/
    activateInEditMode() {
      this.isEditing = true;
      this.edit = false;
      this.style = true;
    },

      refreshData(message,type){
       alert(message,type);
       this.motifUnrached="";
       this.motifAnnulation="";
        this.remindDate=null;
        this.showButtonStart = true;
         this.vShow = true;
          this.order = {
            customer: {},
            details: [],
            seller: {},
            teleConsultant: {},
            skippedBy: [],
            unreachedBy: [],
          };
          this.shipping={}
    },

    async updateData(dataToEdit) {
      this.$confirm(this.$t('update_information')).then(
        async (res) => {
          if (res) {
            const data = await this.$server.update("orders", dataToEdit);
            if (data._id) {
              this.isEditing = false;
              this.style = false;
              this.edit = true;
              alert(this.$t('updated'), "success");
            }
          }
        }
      );
    },
    async desactivateInResetMode() {
      this.isEditing = false;
      this.style = false;
      this.edit = true;
      await this.getOrder();
    },

    ChronoStart() {
      if (this.sec < 60) {
        this.s = setTimeout(() => {
          this.sec += 1;
          this.ChronoStart();
        }, 1000);
        this.remettreAZero();
      } else if (this.min == 60) {
        this.hr += 1;
        this.min = 0;
        this.h = setTimeout(() => {
          this.sec += 1;
          this.ChronoStart();
        }, 1000);
        this.remettreAZero();
      } else {
        this.min += 1;
        this.sec = 0;
        this.m = setTimeout(() => {
          this.sec += 1;
          this.ChronoStart();
        }, 1000);
        this.remettreAZero();
      }
    },

    remettreAZero() {
      if (this.sec < 10) {
        this.zeroS = true;
      } else {
        this.zeroS = false;
      }
      if (this.min < 10) {
        this.zeroM = true;
      } else {
        this.zeroM = false;
      }
      if (this.hr < 10) {
        this.zeroH = true;
      } else {
        this.zeroH = false;
      }
    },
  },
};
</script>


<style scoped>

.intro-y.active {
  border: 5px solid rgba(16, 179, 29, 0.9) !important;
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
}

.btn-marketing {
    -webkit-animation: shadow-pulse 1s infinite;
    animation: shadow-pulse 1s infinite;
}
@keyframes shadow-pulse{ 
    0%{box-shadow:0 0 0 0px rgba(30, 112, 185);}
    100%{box-shadow:0 0 0 15px rgba(0, 0, 0, 0);}
}
#alert-border-1{
  background: #d4e7ff;
}
.phone{
  background-color: #e8bc52;
  border-color: #e8bc52;
  color: #fff !important;
  display: inline-block;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  padding: 2px;
}
.box-3{
  /* background-image: linear-gradient( 117deg,  rgba(123,216,96,1) 39.2%, rgba(255,255,255,1) 156.2% ); */
  /* background-image: linear-gradient( 180.5deg,  rgba(46,255,171,1) 12.3%, rgba(252,251,222,0.46) 92% ); */
  background-image: linear-gradient( 109.6deg,  rgba(223,234,247,1) 11.2%, rgba(244,248,252,1) 91.1% );
}
.flex-shrink-0 {
  -ms-flex-negative: 0 !important;
  flex-shrink: 0 !important;
}
.flex-grow-1 {
  -webkit-box-flex: 1 !important;
  -ms-flex-positive: 1 !important;
  flex-grow: 1 !important;
}
.d-flex {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}
.badge-soft-success {
  color: #e8bc52;
background-color: rgba(232,188,82,.1);
display: inline-block;
padding: 2px 2px;
font-size: 14px;
font-weight: 500;
line-height: 1;
text-align: center;
white-space: nowrap;
vertical-align: baseline;
border-radius: 10px;
}
.card-1{
  margin-bottom: 1.1rem;
  -webkit-box-shadow: 0 1px 2px rgba(56,65,74,.15);
  box-shadow: 0 1px 2px rgba(56,65,74,.15);
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-image: linear-gradient( 181.2deg,  rgba(181,239,249,1) 10.5%, rgba(254,254,254,1) 86.8% );
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 0.25rem;
}
.card-header-1:first-child {
  border-radius: 0.25rem 0.25rem 0 0;
}
.card-header-1 {
  border-bottom: 1px solid #e9ebec;
}
.card-header-1 {
  padding: 1rem 1rem;
  margin-bottom: 0;
  background-color: #fff;
}
.card-title {
  font-size: 17px;
}
h5 {
  font-weight: 600;
  line-height: 1.2;
}
.text-muted {
  --vz-text-opacity: 1;
  color: #878a99 !important;
}
@-moz-keyframes facebookSpinner {
  0% {
    -moz-transform: scale(1, 1);
    transform: scale(1, 1);
    opacity: 1;
  }
  100% {
    -moz-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
    opacity: 0.1;
  }
}
@-webkit-keyframes facebookSpinner {
  0% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
    opacity: 0.1;
  }
}
@keyframes facebookSpinner {
  0% {
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
    opacity: 1;
  }
  100% {
    -moz-transform: scale(0.7, 0.7);
    -ms-transform: scale(0.7, 0.7);
    -webkit-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
    opacity: 0.1;
  }
}
.facebook-spinner {
  width: 25px;
  height: 28px;
  display: inline-block;
  vertical-align: middle;
}
.facebook-spinner .spinner-block {
  float: left;
  width: 7px;
  height: 28px;
  background-color: #8b9dc3;
  border: 1px solid #3b5998;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -moz-animation-name: facebookSpinner;
  -webkit-animation-name: facebookSpinner;
  animation-name: facebookSpinner;
  -moz-animation-duration: 1s;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -moz-animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
.facebook-spinner .spinner-block:not(:last-child) {
  margin-right: 2px;
}
.facebook-spinner .block-1 {
  -moz-animation-delay: 100ms;
  -webkit-animation-delay: 100ms;
  animation-delay: 100ms;
}
.facebook-spinner .block-2 {
  -moz-animation-delay: 200ms;
  -webkit-animation-delay: 200ms;
  animation-delay: 200ms;
}
.facebook-spinner .block-3 {
  -moz-animation-delay: 300ms;
  -webkit-animation-delay: 300ms;
  animation-delay: 300ms;
}


.me-1 {
  margin-right: .25rem !important;
}
.align-middle {
  vertical-align: middle !important;
}
.card-body-1 {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1rem 1rem;
}
.maxx-heigh{
  max-height: 50px;
   overflow-y: scroll;
}
.icon::after {
  content: "";
  display: block;
  position: absolute;
  border-top: 23px solid transparent;
  border-bottom: 17px solid transparent;
  border-left: 12px solid #ed0e0e;
  left: 100%;
  top: 0;
}
.v-select{
  width: 100%;
}
.vs__dropdown-toggle {
    border: none;
}
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}

dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}

@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.label {
  transition: all 0.2s ease-out;
  top: 0.4rem;
  left: 0;
}
.flip-clock {
  text-align: center;
  perspective: 600px;
  margin: 0 auto;
}

.flip-clock__piece {
  display: inline-block;
  margin: 0 0.2vw;
  
  @media (min-width: 1000px) {
    margin: 0 5px;
  }
}

.flip-clock__slot {
  font-size: 1rem;
  line-height: 1.5;
  display: block;
}

.flip-card {
  display: block;
  position: relative;
  padding-bottom: 0.1em;
  font-size: 2.25rem;
  line-height: 0.95;
}

@media (min-width: 1000px) {
  .flip-clock__slot { font-size: 1.2rem; }
  .flip-card { font-size: 3rem; }
}


/*////////////////////////////////////////*/


.flip-card__top,
.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__back::before,
.flip-card__back::after {
  display: block;
  height: 1.44em;
  color: #ccc;
  background: #222;
  padding: 0.23em 0.25em 0.4em;
  border-radius: 0.15em 0.15em 0.15em 0.15em;
  backface-visiblity: hidden;
  transform-style: preserve-3d;
  width: 1.8em;
}

.flip-card__bottom,
.flip-card__back-bottom {
  color: #FFF;
  position: absolute;
  top: 50%;
  left: 0;
  border-top: solid 1px #000;
  background: #393939;
  border-radius: 0 0 0.15em 0.15em;
  pointer-events: none;
  overflow: hidden;
  z-index: 2;
}

.flip-card__back-bottom {
  z-index: 1;
}

.flip-card__bottom::after,
.flip-card__back-bottom::after {
  display: block;
  margin-top: -0.72em;
}

.flip-card__back::before,
.flip-card__bottom::after,
.flip-card__back-bottom::after {
  content: attr(data-value);
}

.flip-card__back {
  position: absolute;
  top: 0;
  height: 100%;
  left: 0%;
  pointer-events: none;
}

.flip-card__back::before {
  position: relative;
  overflow: hidden;
  z-index: -1;
}

.flip .flip-card__back::before {
  z-index: 1;
  animation: flipTop 0.3s cubic-bezier(.37,.01,.94,.35);
  animation-fill-mode: both;
  transform-origin: center bottom;
}

.flip .flip-card__bottom {
  transform-origin: center top;
  animation-fill-mode: both;
  animation: flipBottom 0.6s cubic-bezier(.15,.45,.28,1);
}
.icon-call{
  font-size: 40px;
}
@keyframes flipTop {
  0% {
    transform: rotateX(0deg);
    z-index: 2;
  }
  0%, 99% {
    opacity: 1;
  }
  100% {
    transform: rotateX(-90deg);
    opacity: 0;
  }
}

@keyframes flipBottom {
  0%, 50% {
    z-index: -1;
    transform: rotateX(90deg);
    opacity: 0;
  }
  51% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: rotateX(0deg);
    z-index: 5;
  }
}

.gap-2 {
  gap: .5rem !important;
}
.vstack {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-item-align: stretch;
  align-self: stretch;
}
.card-radio {
  padding: 0;
}
.form-check {
  position: relative;
  text-align: left;
}
.form-check {
  display: block;
  min-height: 1.2375rem;
  margin-bottom: .125rem;
}
.card-radio .form-check-label {
  background-color: #fff;
  border: 1px solid #e7eaec;
  border-radius: .25rem;
  padding: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  position: relative;
  padding-right: 32px;
  cursor: pointer;
  margin-bottom: 0;
  font-weight: 400;
  background-image: linear-gradient(to right, #00b4db80, #0083b005);
}
.align-items-center {
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}
.d-flex {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}
.flex-shrink-0 {
  -ms-flex-negative: 0 !important;
  flex-shrink: 0 !important;
}
.avatar-xs {
  height: 2rem;
  width: 2rem;
}
.avatar-title {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #6691e7;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-weight: 400;
  height: 100%;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 100%;
}
.fs-18 {
  font-size: 18px !important;
}
.rounded {
  border-radius: 0.25 !important;
}
.bg-success-subtle {
  background-color: #daf7e8 !important;
}
.text-success {
  --vz-text-opacity: 1;
  color: rgba(19,197,107,1) !important;
}
.card-radio .form-check-label {
  white-space: nowrap;
}
.form-check label {
  cursor: pointer;
}

/* NEW: Price Reduction specific styles */
.border-red-500 {
  border-color: #ef4444 !important;
}

.text-red-500 {
  color: #ef4444 !important;
}

.bg-green-100 {
  background-color: #dcfce7 !important;
}

.text-green-800 {
  color: #166534 !important;
}

.bg-gray-100 {
  background-color: #f3f4f6 !important;
}
/* Animation marketing pour attirer l'attention */
.btn-marketing {
  animation: subtle-pulse 3s ease-in-out infinite;
}

@keyframes subtle-pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }
  50% {
    transform: scale(1.005);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }
}

/* Gradient backgrounds */
/* .bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
} */

.from-green-50 {
  --tw-gradient-from: #f0fdf4;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(240, 253, 244, 0));
}

.to-emerald-50 {
  --tw-gradient-to: #ecfdf5;
}

.from-red-50 {
  --tw-gradient-from: #fef2f2;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(254, 242, 242, 0));
}

.to-pink-50 {
  --tw-gradient-to: #fdf2f8;
}

.from-orange-50 {
  --tw-gradient-from: #fff7ed;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(255, 247, 237, 0));
}

.to-yellow-50 {
  --tw-gradient-to: #fffbeb;
}

/* Text decoration */
.line-through {
  text-decoration: line-through;
}

/* Responsive design */
@media (max-width: 768px) {
  .grid-cols-1.md\:grid-cols-2 {
    grid-template-columns: 1fr;
  }
}

.action-buttons-section {
  width: 100%;
  padding: 20px;
  background: #ffffff;
}

.button-group {
  max-width: 1200px;
  margin: 0 auto;
}

.button-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.action-button {
  flex: 1;
  min-width: 150px;
  max-width: 200px;
  height: 50px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  padding: 0 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.action-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.action-button:active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.action-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.3);
}

.confirm-button {
  min-width: 180px;
  height: 55px;
  font-size: 16px;
}

/* Couleurs des boutons - Style 2020 */
.green-button {
  background-color: #48bb78;
  border: 1px solid #38a169;
}

.green-button:hover {
  background-color: #38a169;
  border-color: #2f855a;
}

.blue-button {
  background-color: #4299e1;
  border: 1px solid #3182ce;
}

.blue-button:hover {
  background-color: #3182ce;
  border-color: #2c5282;
}

.purple-button {
  background-color: #9f7aea;
  border: 1px solid #805ad5;
}

.purple-button:hover {
  background-color: #805ad5;
  border-color: #6b46c1;
}

.yellow-button {
  background-color: #ed8936;
  border: 1px solid #dd6b20;
}

.yellow-button:hover {
  background-color: #dd6b20;
  border-color: #c05621;
}

.orange-button {
  background-color: #f6ad55;
  border: 1px solid #ed8936;
}

.orange-button:hover {
  background-color: #ed8936;
  border-color: #dd6b20;
}

.orange-alt-button {
  background-color: #ff8c42;
  border: 1px solid #ff7420;
}

.orange-alt-button:hover {
  background-color: #ff7420;
  border-color: #e85d00;
}

.red-button {
  background-color: #f56565;
  border: 1px solid #e53e3e;
}

.red-button:hover {
  background-color: #e53e3e;
  border-color: #c53030;
}

/* Responsive Design */

/* Tablettes */
@media (max-width: 1024px) {
  .action-button {
    min-width: 140px;
    max-width: 180px;
    font-size: 13px;
  }
  
  .confirm-button {
    min-width: 160px;
    font-size: 15px;
  }
}

/* Tablettes petites */
@media (max-width: 768px) {
  .button-row {
    gap: 12px;
  }
  
  .action-button {
    min-width: 120px;
    max-width: 160px;
    height: 45px;
    font-size: 12px;
  }
  
  .confirm-button {
    min-width: 140px;
    height: 50px;
    font-size: 14px;
  }
}

/* Mobile */
@media (max-width: 640px) {
  .action-buttons-section {
    padding: 15px;
  }
  
  .button-row {
    flex-direction: column;
    gap: 10px;
  }
  
  .action-button {
    flex: none;
    width: 100%;
    max-width: none;
    min-width: auto;
    height: 48px;
    font-size: 14px;
  }
  
  .confirm-button {
    width: 100%;
    min-width: auto;
    height: 52px;
    font-size: 16px;
  }
}

/* Mobile petit */
@media (max-width: 480px) {
  .action-buttons-section {
    padding: 10px;
  }
  
  .button-row {
    gap: 8px;
  }
  
  .action-button {
    height: 44px;
    font-size: 13px;
  }
  
  .confirm-button {
    height: 48px;
    font-size: 15px;
  }
}

/* Très petit mobile */
@media (max-width: 320px) {
  .action-button {
    height: 40px;
    font-size: 12px;
    padding: 0 12px;
  }
  
  .confirm-button {
    height: 44px;
    font-size: 14px;
  }
}

/* États des boutons */
.action-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.action-button:disabled:hover {
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.reduction-reject{
  background-image: linear-gradient(to right, #fccfcf, #ffc4c4);
}
.reduction-accept{
  background-image: linear-gradient(to right, #98f3bb, #b4f5cd);
}



</style>



